import environment from './environment'
import { mainNetworks, testNetworks } from './networks'
import { arbitrumSepoliaChainConfig } from './networks/arbitrum-sepolia'
import { mainnetBridges, testnetBridges } from './networks/bridges'
import { polygonChainConfig } from './networks/polygon'
import resources from './resources'

const { isProdMode, isDevMode, appApiUrl, alchemyApiKey } = environment

const chainNameSearchParam = new URLSearchParams(window.location.search).get(
  'chain'
)
const chainSearchParam = mainNetworks.find(
  chain => chain.name === chainNameSearchParam
)
const lastChainId = localStorage.getItem('lastChainId')
const lastChain = mainNetworks.find(chain => chain.id === Number(lastChainId))
const prodDefaultChain = chainSearchParam || lastChain || polygonChainConfig

const defaultChain = isProdMode ? prodDefaultChain : arbitrumSepoliaChainConfig

const supportedChains = isProdMode ? mainNetworks : testNetworks

const networksBridges = isProdMode ? mainnetBridges : testnetBridges

const staticConfig = Object.freeze({
  defaultChain: defaultChain,
  supportedChains: supportedChains,
  thirdWebClientId: environment.thirdWebClientId,
  appApiUrl,
  alchemyApiKey,
  networksBridges,
  resources,
  isProdMode,
  isDevMode,
})

export default staticConfig
